/**
 * URL Utilities for handling development and production environments
 */

/**
 * Gets the correct base URL for the application based on environment
 */
export const getBaseUrl = (): string => {
  if (process.env.NODE_ENV === 'production') {
    // In production, use environment variable or fallback to known production domain
    return process.env.REACT_APP_PRODUCTION_URL || 'https://answer.thrivewithdory.com';
  }
  
  // In development, use current origin (localhost)
  return window.location.origin;
};

/**
 * Gets the participant URL for QR codes and sharing
 */
export const getParticipantUrl = (): string => {
  return `${getBaseUrl()}/participate`;
};

/**
 * Gets the presenter URL
 */
export const getPresenterUrl = (): string => {
  return `${getBaseUrl()}/present`;
};

/**
 * Logs the current environment and URLs for debugging
 */
export const logEnvironmentInfo = (): void => {
  console.log('🌍 Environment Info:', {
    NODE_ENV: process.env.NODE_ENV,
    baseUrl: getBaseUrl(),
    participantUrl: getParticipantUrl(),
    presenterUrl: getPresenterUrl(),
    customProductionUrl: process.env.REACT_APP_PRODUCTION_URL
  });
}; 